import { IconButton, Tooltip } from "@mui/material";
import { Check, Clear, Edit } from "@mui/icons-material";
import * as React from "react";
import { ProperyChangeType } from "./customizationHelpers";
import CustomizeItem from "./CustomizeItem";
import { CustomizeItemDropdownValue } from "./CustomizeItemDropdown";

export const MIN_LATENCY: number = 0.5;
export const MAX_LATENCY: number = 30;
export const LATENCY_STEP: number = 0.5;

interface Props {
    currentTargetLatency: number;
    onCustomizationChange: (type: ProperyChangeType, key: string, value: number) => void;
}

function ChannelCustomizerLatency({ currentTargetLatency, onCustomizationChange }: Props) {
    const [targetLatency, setTargetLatency] = React.useState<number>(currentTargetLatency);
    const [editTarget, setEditTarget] = React.useState<boolean>(false);

    React.useEffect(() => {
        setTargetLatency(currentTargetLatency);
    }, [currentTargetLatency]);

    function onSaveLatency(): void {
        onCustomizationChange("latency", "targetLatency", targetLatency);
        setEditTarget(false);
    }

    function onDiscardLatencyChanges(): void {
        setTargetLatency(currentTargetLatency);
        setEditTarget(false);
    }

    const values: CustomizeItemDropdownValue[] = [];
    for (let i = MIN_LATENCY; i <= MAX_LATENCY; i = i + LATENCY_STEP) {
        values.push({
            key: i,
            value: getLabel(i),
        });
    }

    function getLabel(i: number): string {
        if (i === MIN_LATENCY) {
            return `<1 sec (Optimized latency)`;
        }

        if (i === MAX_LATENCY) {
            return `${MAX_LATENCY} sec (Optimized network latency)`;
        }

        return `${i} sec`;
    }

    return (
        <>
            <CustomizeItem
                title={"Network resilience"}
                description={"Choose for Optimized latency or Optimized network resilience by setting target latency"}
                currentValue={targetLatency < MIN_LATENCY ? MIN_LATENCY : targetLatency}
                isEditable={editTarget}
                type="number-range"
                numberRangeValues={values}
                onValueChange={(val: string | number) => typeof val === "number" && setTargetLatency(val)}
                onDoubleClick={() => setEditTarget(true)}
                unit="second"
                min={MIN_LATENCY}
                max={MAX_LATENCY}
                step={0.5}
                customizationActions={
                    <>
                        {!editTarget && (
                            <>
                                <Tooltip title="Edit">
                                    <IconButton size="small" onClick={() => setEditTarget(true)}>
                                        <Edit fontSize="small" style={{ color: "black" }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                        {editTarget && (
                            <>
                                <Tooltip title="Save">
                                    <IconButton size="small" onClick={onSaveLatency}>
                                        <Check fontSize="small" style={{ color: "black" }} />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Discard">
                                    <IconButton size="small" onClick={onDiscardLatencyChanges}>
                                        <Clear fontSize="small" style={{ color: "black" }} />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                    </>
                }
            />
        </>
    );
}

export default ChannelCustomizerLatency;
